import * as React from 'react';
import { connect } from 'react-redux';
import { withNavigation } from '../General/withNavigation';
import { toast } from 'react-toastify';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import Auth from '../../auth';
import ClickOutsideHandler from '../General/ClickOutsideHandler';
import GoBackArrow from '../General/GoBackArrow';
import Tab from '../General/Tab';
import MiniSpinner from '../General/MiniSpinner';
import DatosBasicos from './DatosBasicos';
import DatosContactos from './DatosContactos';
import Publicacion from './Publicacion';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import Liquidacion from './Liquidacion';
import { postTiposPublicacionAsociarSeller } from '../../api/axios';
import { postSeller } from '../../api/axios';
import { fetchSeller, editSeller, setFiltroSeller } from '../../actions/sellersActions';
import { editando, setObject, limpiarFiltros } from '../../actions/generalActios';
import { isEmail } from '../../utilities/formatString';
import { resolveTipoPublicacionId } from '../../helper/tipoPublicacionHelper';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

function toastErroresApi(errs) {
    if (!Array.isArray(errs) || !errs.length) return false;
    errs.forEach((e) => {
        if (e && typeof e === 'object' && ('item1' in e || 'item2' in e)) {
            const msg = [e.item1, e.item2, e.item3, e.item4].filter(Boolean).join(' — ');
            if (msg) toast.error(msg);
        } else if (typeof e === 'string') toast.error(e);
        else if (e != null) toast.error(String(e));
    });
    return true;
}

class SellerNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: this.props.location?.state ?? 0,
            showSpinner: false
        };
    }

    /** Metadatos de pestañas; el JSX de cada panel se arma en render para que siempre reciba props actuales y no queden instancias “congeladas” al cambiar de pestaña. */
    getTabDefinitions = () => [
        { name: "Datos Básicos ", icon: "ti-home" },
        { name: "Datos de contactos", icon: "ti-home" },
        { name: "Publicación", icon: "ti-home" },
        { name: "Moderador", icon: "ti-home" },
        { name: "Usuario", icon: "ti-home" },
        { name: "Liquidacion", icon: "ti-home" },
    ];

    renderActiveTabContent = () => {
        const { history, navigate, location, tipoUsuario } = this.props;
        const i = this.state.activeTab;
        switch (i) {
            case 0:
                return <DatosBasicos key="seller-new-tab-0" />;
            case 1:
                return <DatosContactos key="seller-new-tab-1" />;
            case 2:
                return <Publicacion key="seller-new-tab-2" history={history} />;
            case 3:
                return (
                    <Moderador
                        key="seller-new-tab-3"
                        tipoUsuario={tipoUsuario}
                        history={history}
                        navigate={navigate}
                        location={location}
                        changeTab={this.onChangeActiveTab}
                    />
                );
            case 4:
                return <MailUsuario key="seller-new-tab-4" />;
            case 5:
                return <Liquidacion key="seller-new-tab-5" tipoUsuario={tipoUsuario} />;
            default:
                return null;
        }
    };

    componentDidMount() {
        const { location } = this.props;

        if (location.pathname !== "/Sellers/Nuevo/Select") {
            this.props.setObject({});
        }
        this.props.editando(false);
        // Tras elegir tipos de publicación se navega a /Sellers/Nuevo/Select con setObject(seller).
        // fetchSeller() sin id reemplaza sellers.seller por el template vacío y el merge con generalObject
        // dejaba los campos en blanco (el template pisa al snapshot).
        if (location.pathname !== "/Sellers/Nuevo/Select") {
            this.props.fetchSeller();
        }
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            seller: {
                ...prevState.seller,
                [name]: value
            }
        }));
    }

    asignarTipoPublicacion = (idSeller) => {
        const { settedTiposPublicacion } = this.props;
        const tiposArr = Array.isArray(settedTiposPublicacion) ? settedTiposPublicacion : [];
        const idSellerNum = parseInt(idSeller, 10);
        const listaIdsTipoPublicacion = tiposArr
            .map((t) => resolveTipoPublicacionId(t))
            .filter((id) => id != null && Number.isFinite(id) && id > 0);

        const request = {
            idSeller: Number.isFinite(idSellerNum) && idSellerNum > 0 ? idSellerNum : 0,
            listaIdsTipoPublicacion
        };

        if (request.idSeller <= 0 || request.listaIdsTipoPublicacion.length === 0) {
            return;
        }

        const req = postTiposPublicacionAsociarSeller(request);
        req.then(res => {
            toast.success("Tipo de publicación asociado");
        }).catch(err => {
            toast.warn("Tipo de publicación no asociado");
        });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        const { userType } = this.props;
        if (userType.isAdminMod || userType.isCategory) {

            let seller = this.props.seller;

            if (seller.password !== seller.confirmarPassword) {
                toast.warn("Las contraseñas no coinciden, verifique");
                return;
            }

            if (!isEmail(seller.email)) {
                toast.warn("e-Mail contacto comercial incorrecto");
                return;
            }

            if (!isEmail(seller.emailUsuario)) {
                toast.warn("e-Mail de usuario incorrecto");
                return;
            }

            const trim = (v) => (v == null ? '' : String(v).trim());
            const pwd = trim(seller.password);
            if (!pwd || pwd.length < 6) {
                toast.warn("La contraseña debe tener al menos 6 caracteres");
                return;
            }
            if (!trim(seller.razonSocial)) {
                toast.warn("Completá la razón social");
                return;
            }
            if (!trim(seller.nombreTienda)) {
                toast.warn("Completá el nombre de tienda");
                return;
            }
            if (!trim(seller.nombreUsuario)) {
                toast.warn("Completá el nombre de usuario");
                return;
            }
            const suf = trim(seller.sufijo);
            if (!suf) {
                toast.warn("Completá el sufijo SKU (Moderador)");
                return;
            }
            const cuitDigits = trim(seller.cuit).replace(/\D/g, '');
            if (cuitDigits.length !== 11) {
                toast.warn("CUIT inválido: deben ser 11 dígitos");
                return;
            }

            this.setState({ showSpinner: true });

            const sellerModificado = {
                ...seller,
                modalidadEPK: "s",
            };

            let sellers = postSeller(sellerModificado);

            sellers.then(res => {
                if (res?.errores?.length) {
                    toastErroresApi(res.errores);
                    return;
                }
                this.asignarTipoPublicacion(res.idSeller);
                toast.success("Seller agregado con éxito");
                //this.agregarCDNAlSeller(res.idSeller);
                this.afterSellerCreated();
            }).catch(err => {
                const errores = err?.response?.data?.errores;
                if (toastErroresApi(errores)) return;
                toast.error("El seller no pudo ser creado");
            }).finally(() => {
                this.setState({ showSpinner: false });
            });
        }
    }

    redirectToSellers = () => {
        this.props.navigate("/Sellers");
    }

    afterSellerCreated = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, sellers: true });
        this.props.setFiltroSeller({
            razonSocial: "",
            cantidadPagina: 10,
            numeroPagina: 1,
            showFilter: false
        });
        this.redirectToSellers();
    }

    render() {
        const { userType } = this.props;
        const canCreateSeller = userType.isAdminMod || userType.isCategory;
        const tabDefs = this.getTabDefinitions();

        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">

                        <div className="col-12 mb-3">
                            <GoBackArrow />
                            <h4 className="card-title d-block d-sm-inline">Nuevo Seller</h4>
                        </div>

                        <ul className="nav nav-tabs customtab" role="tablist">
                            {
                                tabDefs.map((tab, index) => {
                                    return (<div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                        <Tab
                                            name={tab.name}
                                            icon={tab.icon}
                                            isActive={index === this.state.activeTab}
                                        />
                                    </div>)
                                })
                            }
                        </ul>

                        <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                {this.renderActiveTabContent()}

                                <div className="row align-items-center justify-content-center text-center">
                                    <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                        <MiniSpinner />
                                    </div>

                                    <div className="col-12 col-sm-auto d-flex justify-content-center mt-4">
                                        {canCreateSeller && (
                                            <button
                                                type="submit"
                                                disabled={this.state.showSpinner}
                                                className="btn btn-sm background-rojo-megatone waves-light mx-2"
                                            >
                                                Crear Seller
                                            </button>
                                        )}

                                        <button
                                            onClick={() => this.props.navigate("/Sellers")}
                                            className="btn btn-sm btn-light waves-effect waves-light mx-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    settedSellerObject: state.general.generalObject,
    emptyFilters: state.general.limpiar,
    seller: selectSellerMerged(state),
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    userType: state.general.userType,
});

const mapDispatchToProps = {
    fetchSeller,
    editSeller,
    editando,
    setTiposPublicacion,
    setObject,
    limpiarFiltros,
    setFiltroSeller,
    createSeller: (seller) => ({ type: 'CREATE_SELLER', payload: seller })
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(SellerNew));